const routerHistory = (state = [], action) => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    return [...state, action.payload];
  }
  return state;
};

export default routerHistory;
